// extracted by mini-css-extract-plugin
export default {"validationInfoWrapper":"_5167cce55acaa5c2","letter":"b6e45b7b33740d9a"};